import { createSlice } from '@reduxjs/toolkit';

const chatsSlice = createSlice({
  name: 'chats',
  initialState: {
    chats: {}, // { chatId: { id, user_ids, user1_id, user2_id, last_message, last_message_time, read_by, matched_at } }
    loading: false,
    unreadCount: 2, // Total unread messages across all chats
  },
  reducers: {
    setChats: (state, action) => {
      state.chats = action.payload;
    },
    // Add or update a single chat in the chats object
    addChat: (state, action) => {
      const { chatId, chat } = action.payload;
      state.chats[chatId] = chat;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
});

export const { setChats, addChat, setLoading, setUnreadCount } = chatsSlice.actions;
export default chatsSlice.reducer;
